export default __webpack_public_path__ + "static/favorite-vehicle-empty-state-628e0b2e9d9fa08eae9194b0b9cfc799.png";